import React, { useState } from 'react';
import { Lock, Save, AlertCircle, CheckCircle } from 'lucide-react';
import { API_URL } from '../config/api';
import './Settings.css';

const Settings = () => {
    const [formData, setFormData] = useState({
        current_password: '',
        new_password: '',
        confirm_password: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: '', message: '' });

        if (formData.new_password !== formData.confirm_password) {
            setStatus({ type: 'error', message: 'Las nuevas contraseñas no coinciden' });
            return;
        }

        if (formData.new_password.length < 6) {
            setStatus({ type: 'error', message: 'La contraseña debe tener al menos 6 caracteres' });
            return;
        }

        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/users/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    current_password: formData.current_password,
                    new_password: formData.new_password
                })
            });

            const data = await response.json();

            if (response.ok) {
                setStatus({ type: 'success', message: 'Contraseña actualizada correctamente' });
                setFormData({
                    current_password: '',
                    new_password: '',
                    confirm_password: ''
                });
            } else {
                setStatus({ type: 'error', message: data.message || 'Error al cambiar la contraseña' });
            }
        } catch (error) {
            console.error('Error changing password:', error);
            setStatus({ type: 'error', message: 'Error de conexión' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="settings-container">
            <div className="settings-card">
                <div className="settings-header">
                    <div className="settings-title-wrapper">
                        <div className="settings-title">
                            <Lock size={28} />
                            <h2>Cambiar Contraseña</h2>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="settings-form">
                    <div className="form-group">
                        <label>Contraseña Actual</label>
                        <input
                            type="password"
                            name="current_password"
                            value={formData.current_password}
                            onChange={handleChange}
                            required
                            placeholder="Introduce tu contraseña actual"
                        />
                    </div>

                    <div className="form-group">
                        <label>Nueva Contraseña</label>
                        <input
                            type="password"
                            name="new_password"
                            value={formData.new_password}
                            onChange={handleChange}
                            required
                            placeholder="Mínimo 6 caracteres"
                        />
                    </div>

                    <div className="form-group">
                        <label>Confirmar Nueva Contraseña</label>
                        <input
                            type="password"
                            name="confirm_password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                            required
                            placeholder="Repite la nueva contraseña"
                        />
                    </div>

                    {status.message && (
                        <div className={`status-message ${status.type}`}>
                            {status.type === 'error' ? <AlertCircle size={18} /> : <CheckCircle size={18} />}
                            {status.message}
                        </div>
                    )}

                    <button type="submit" className="btn-save-settings" disabled={loading}>
                        {loading ? 'Guardando...' : (
                            <>
                                <Save size={18} /> Actualizar Contraseña
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Settings;
